export default __webpack_public_path__ + "static/media/chat.e3b52b6d.svg";